import { FulfillmentName } from '@/types';
// TODO: [DSR-3429] Future refactor — move fulfillment logic to a pure domain at `domains/fulfillment-settings`.
import { OrderAvailability } from '@domain/fulfillment-settings/blocs/order-availability';
import { useAvailableOrderFulfillments } from '@/hooks/orders/use-available-order-fulfillments';
import { useCallback, useMemo } from 'react';

export interface AvailabilityConstraints {
  cutoffTimeString: string;
  orderMinimumDisplayString: string | undefined;
}

export const useSalesPortalAvailableOrderFulfillmentsLoader = ({
  restaurantUUID,
  supplierUUID,
}: {
  restaurantUUID: string;
  supplierUUID: string;
}) => {
  const { data, refetch, loading } = useAvailableOrderFulfillments({
    restaurantUUID,
    supplierUUID,
  });
  const availableFulfillments = useMemo(
    () => data?.getAvailableOrderFulfillments ?? [],
    [data],
  );
  const selectableFulfillmentOptions = useMemo(
    () =>
      availableFulfillments.filter(
        (fulfillment) => !fulfillment.primary_fulfillment_settings_id,
      ),
    [availableFulfillments],
  );
  const getAvailabilityConstraints = useCallback(
    (
      fulfillmentName: FulfillmentName,
      deliveryDate: string,
      restaurantTimezone: string,
      supplierTimezone: string,
    ): AvailabilityConstraints => {
      const orderAvailabilityService = new OrderAvailability(
        availableFulfillments,
        {
          restaurant: restaurantTimezone,
          supplier: supplierTimezone,
        },
        fulfillmentName,
      );
      const formattedCutoffTime = orderAvailabilityService.getCutoffForDate(
        deliveryDate,
        true,
      );

      return {
        cutoffTimeString: formattedCutoffTime,
        orderMinimumDisplayString:
          orderAvailabilityService.selectedAvailability
            ?.order_minimum_display_string ?? undefined,
      };
    },
    [availableFulfillments],
  );

  return {
    availableFulfillments,
    getAvailabilityConstraints,
    loading,
    refetch,
    selectableFulfillmentOptions,
  };
};
